import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@material-ui/core';
import moment from 'moment';
import { Modal } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import useGetDeliveryEvents from '../../../../hooks/delivery-events/useGetDeliveryEvents';
import CustomizedTimeline, { TimeLineEvent } from '../../../TimeLine/Timeline';
import colors from '../../../../assets/styles/colors';
import '../delivery-history/styles.scss';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';

interface FreightHistoricProps {
  isOpen: boolean;
  setShowHistory: (isOpen: false) => void;
}

const FreightHistoric: React.FC<FreightHistoricProps> = ({
  isOpen,
  setShowHistory,
}) => {
  const { id } = useParams<{ id: string }>();
  const { execute, loading } = useGetDeliveryEvents();
  const [events, setEvents] = useState<TimeLineEvent[]>([]);
  const { freight } = useSelector((state: ApplicationState) => state.freight);

  useEffect(() => {
    const fetchFreightHistory = async () => {
      if (!id) return;

      console.log('[FreightHistoric] freightId:', id);
      console.log('[FreightHistoric] freight from store:', freight);

      const data = await execute({ freightId: id });
      console.log('[FreightHistoric] raw data:', data);

      if (!data) return;

      const items = (Array.isArray(data) ? data : []) as Array<{
        timestamp: string | Date;
        status?: string;
        problemDescription?: string;
      }>;

      const timeline = items
        .sort(
          (a: { timestamp: string | Date }, b: { timestamp: string | Date }) =>
            new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime(),
        )
        .map(
          (e: {
            timestamp: string | Date;
            status?: string;
            problemDescription?: string;
          }) => ({
            time: moment(e.timestamp).format('DD/MM/yyyy HH:mm'),
            content: e.problemDescription
              ? `${e.status || ''} - ${e.problemDescription}`
              : e.status || '',
            dotColor: colors.primary.orange,
          }),
        ) as TimeLineEvent[];

      setEvents(timeline);
    };

    fetchFreightHistory();
  }, [id]);

  return (
    <Modal
      centered
      onHide={() => setShowHistory(false)}
      size="lg"
      show={isOpen}
    >
      <Modal.Header closeButton>
        <Modal.Title>Histórico geral do frete</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="container-historic">
          {loading ? (
            <CircularProgress />
          ) : (
            <div>
              <div>
                {events.length > 0 ? (
                  <CustomizedTimeline timelineData={events} />
                ) : (
                  <div style={{ textAlign: 'center', padding: '20px' }}>
                    <p>Nenhum evento encontrado para este frete.</p>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default FreightHistoric;
